import React from 'react';
import { fetchAuthSession } from '@aws-amplify/auth';


const RemoveAccess = async (capsuleID: string, user: string) => {
  const apiUrl = `https://lfnawfdz0a.execute-api.ap-southeast-2.amazonaws.com/capsule/removeaccess/${capsuleID}`; 
  const payload = {
    "user": user
  }

  try {
    const { tokens } = await fetchAuthSession();
    const authToken = tokens?.accessToken?.toString();

    const response = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'x-api-key': authToken!, // Assuming token is available in fetchAuthSession
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (response.ok) {
      const data = await response.json();
      console.log(response);
      return data;
    } else {
      console.error('Failed to remove access');
      return null;
    }
  } catch (err) {
    console.error('Failed to remove access', err);
    return null;
  }
};

export default RemoveAccess;
